import { type FC } from "react";

import { type TooltipContentProps } from "recharts";

import { formatNumberNoSuffix } from "../../../../lens-stats/formatters";
import { type FunnelItem } from "../../../models/dimension-funnel";

import { FunnelLabeledMetric } from "./FunnelLabeledMetric";
import { ActiveDot, Body, Container, Header } from "./engagementFunnelTooltip.styles";

export const EngagementFunnelTooltip: FC<TooltipContentProps> = ({ active, payload }) => {
    if (!active || payload.length === 0) {
        return null;
    }

    const funnelItem = payload[0]?.payload as FunnelItem | undefined;

    if (!funnelItem) {
        return null;
    }

    const { value, fractionFromPreviousPercentFormatted, fractionFromTotalPercentFormatted, labelPrevious, label } =
        funnelItem;

    return (
        <Container role="dialog" aria-hidden={active}>
            <Header>{label}</Header>
            <Body>
                <ActiveDot />
                <div>
                    <FunnelLabeledMetric label={`Total ${label}`}>{formatNumberNoSuffix(value)}</FunnelLabeledMetric>
                    {fractionFromPreviousPercentFormatted && (
                        <FunnelLabeledMetric label={`% retained from ${labelPrevious}`}>
                            {fractionFromPreviousPercentFormatted}
                        </FunnelLabeledMetric>
                    )}
                    {fractionFromTotalPercentFormatted && (
                        <FunnelLabeledMetric label={`% retained from Total`}>
                            {fractionFromTotalPercentFormatted}
                        </FunnelLabeledMetric>
                    )}
                </div>
            </Body>
        </Container>
    );
};
